// extracted by mini-css-extract-plugin
export var wordContainer = "_ox-0";